<template>
  <div>
    <pageHeader :headerIcon="'dolly flatbed'"
                :headerText="'Supppliers'"
                :haveFilterInput="false">
    </pageHeader>
    <!-- navigateTo('Show_Employee', { key: 'params', value: { id: employee.id } }) -->
    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div class="ui three column grid" v-if="!loading" style="margin-top: 40px !important">
      <div class="ui placeholder segment" style="margin-top: 30px; width: 100%" v-if="!suppliers.length">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No Suppliers have been added
        </div>
        <div class="ui primary button" style="background-color: #092442"
             @click="navigateTo('New_Supplier')">
          Add Supplier
        </div>
      </div>

      <div class="column" v-for="supplier in suppliers" v-else>
        <div class="ui raised link fluid stackable blue card"
             @click="navigateTo('Show_Supplier', { key: 'params', value: { id: supplier.id } })">
          <div class="content">
            <div class="header" style="display:flex; align-items:center">
              {{ supplier.name }}
            </div>

            <div class="description">
              <strong> {{ $t('email') }}: </strong> {{ supplier.email }}
            </div>
            <div class="description">
              <strong> Number of branches: </strong> {{ supplier.branches.length }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      suppliers: [],
      loading: true
    }
  },
  mounted () {
    this.$http.get('companies').then(response => {
      this.suppliers = response.data
      this.loading = false
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/inventory_system/companies/Companies.vue